export const LogoSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.5 19">
        <g
            id="Group_1"
            dataname="Group 1"
            transform="translate(-41.281 -32.89)"
        >
            <text
                id="Veditor"
                transform="translate(42.281 47.89)"
                fill="#fff"
                stroke="#fff"
                strokeWidth="1"
                fontSize="17"
                lineheight="17"
                fontFamily="AbeatbyKai, abeatbyKai"
                letterSpacing="0.1em"
            >
                <tspan x="0" y="0">
                    veditor
                </tspan>
            </text>
            <circle
                id="Ellipse_4"
                dataname="Ellipse 4"
                cx="4.348"
                cy="4.348"
                r="4.348"
                transform="translate(110.085 40.219)"
                fill="#6ffcb0"
            />
        </g>
    </svg>
);

export const MenuSVG = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 17 13"
        width="17"
        height="13"
    >
        <defs>
            <clipPath id="clip-path">
                <rect width="17" height="13" fill="none" />
            </clipPath>
        </defs>
        <g
            id="Repeat_Grid_1"
            dataname="Repeat Grid 1"
            clipPath="url(#clip-path)"
        >
            <g transform="translate(-31 -35)">
                <rect
                    id="Rectangle_5"
                    dataname="Rectangle 5"
                    width="17"
                    height="3"
                    rx="1.5"
                    transform="translate(31 35)"
                    fill="#fff"
                />
            </g>
            <g transform="translate(-31 -30)">
                <rect
                    id="Rectangle_5-2"
                    dataname="Rectangle 5"
                    width="17"
                    height="3"
                    rx="1.5"
                    transform="translate(31 35)"
                    fill="#fff"
                />
            </g>
            <g transform="translate(-31 -25)">
                <rect
                    id="Rectangle_5-3"
                    dataname="Rectangle 5"
                    width="17"
                    height="3"
                    rx="1.5"
                    transform="translate(31 35)"
                    fill="#fff"
                />
            </g>
        </g>
    </svg>
);

export const NavSVG1 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.909"
        height="28.54"
        viewBox="0 0 23.909 28.54"
    >
        <g
            id="Group_84"
            dataname="Group 84"
            transform="translate(-560.74 -663.034)"
        >
            <path
                id="Path_480"
                dataname="Path 480"
                d="M583.332,663.034H562.061a1.323,1.323,0,0,0-1.321,1.321v13.293a1.315,1.315,0,0,0,1.316,1.312h6.2l1.6,2.093-1.7,2.967a3.772,3.772,0,1,0,3.191,1.758l1.066-1.388,1.058,1.388a3.777,3.777,0,1,0,3.2-1.758l-1.7-2.967,1.6-2.093h6.756a1.314,1.314,0,0,0,1.312-1.312V664.355A1.32,1.32,0,0,0,583.332,663.034Zm-12.557,22.035a3.615,3.615,0,0,0-.736-.553,3.841,3.841,0,0,0-.915-.375c2.235-3.917,9.048-15.841,9.023-15.8a11.319,11.319,0,0,1-1.977,9.683Zm4.021-.553a3.8,3.8,0,0,0-.736.553l-1.08-1.41,1.41-1.839,1.321,2.32A3.836,3.836,0,0,0,574.8,684.516ZM561.632,667h5.221V675h-5.221Zm7.675,8.9h1.664v2.173h-1.664ZM567.745,675V667h9.9v.62c-.319.226-.074.018-4.32,7.385Zm16.011,0h-4.984a12.256,12.256,0,0,0,.245-6.859.873.873,0,0,0-.482-.6V667h5.221Zm-2.557-8.9h-1.664v-2.178H581.2Zm-5.114,0h-1.664v-2.178h1.664Zm-5.114,0h-1.664v-2.178h1.664Zm-5.118,0h-1.664v-2.178h1.664Zm-1.664,9.79h1.664v2.173h-1.664Zm15.346,0H581.2v2.173h-1.664Zm-9.4,13.03a2.271,2.271,0,1,1,.223-1.728,2.276,2.276,0,0,1-.223,1.728Zm8.51-2.258a2.272,2.272,0,1,1-1.377-1.069,2.276,2.276,0,0,1,1.377,1.069Z"
                fill="#BFBFBF"
            />
            <path
                id="Path_481"
                dataname="Path 481"
                d="M586.4,700.7a.733.733,0,1,0,.522.214A.736.736,0,0,0,586.4,700.7Z"
                transform="translate(-13.799 -20.858)"
                fill="#BFBFBF"
            />
        </g>
    </svg>
);

export const NavSVG2 = () => (
    <svg
        width="30"
        height="22"
        viewBox="0 0 30 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M27.743 6.07966e-06H1.95502C1.60589 0.000535062 1.27122 0.139457 1.02435 0.386328C0.777482 0.633199 0.638529 0.96788 0.638 1.31701V19.79C0.638529 20.1378 0.776955 20.4712 1.02289 20.7171C1.26882 20.9631 1.60221 21.1015 1.95001 21.102H27.75C28.0986 21.1025 28.4331 20.9646 28.6801 20.7186C28.927 20.4726 29.0662 20.1386 29.067 19.79V1.31601C29.0665 1.14266 29.0318 0.97112 28.965 0.811171C28.8981 0.651222 28.8005 0.505997 28.6776 0.383795C28.5546 0.261593 28.4088 0.164802 28.2485 0.0989517C28.0881 0.0331011 27.9163 -0.000520004 27.743 6.07966e-06ZM28.171 16.541H22.182V4.56H28.171V16.541ZM1.53101 4.56H7.521V16.539H1.53101V4.56ZM21.29 16.539H8.414V4.56H21.29V16.539ZM25.11 3.66701H22.945V0.891005H25.11V3.66701ZM18.995 3.66701H16.826V0.891005H19L18.995 3.66701ZM12.876 3.66701H10.707V0.891005H12.876V3.66701ZM6.75598 3.66701H4.58698V0.891005H6.75598V3.66701ZM4.58698 17.432H6.75598V20.208H4.58698V17.432ZM10.706 17.432H12.875V20.208H10.706V17.432ZM16.825 17.432H19V20.208H16.831L16.825 17.432ZM22.944 17.432H25.109V20.208H22.944V17.432Z"
            fill="#BFBFBF"
        />
        <path
            d="M14.85 5.94897C13.9402 5.94897 13.0508 6.21876 12.2944 6.72421C11.5379 7.22967 10.9483 7.94809 10.6002 8.78863C10.252 9.62917 10.1609 10.5541 10.3384 11.4464C10.5159 12.3387 10.954 13.1583 11.5973 13.8017C12.2406 14.445 13.0603 14.8831 13.9526 15.0606C14.8449 15.2381 15.7698 15.147 16.6104 14.7988C17.4509 14.4507 18.1693 13.8611 18.6748 13.1046C19.1802 12.3481 19.45 11.4588 19.45 10.549C19.45 9.32898 18.9653 8.15895 18.1027 7.29628C17.24 6.43361 16.07 5.94897 14.85 5.94897V5.94897ZM16.287 11.399L14.68 12.363C14.5165 12.4602 14.3303 12.5124 14.1401 12.5144C13.9499 12.5163 13.7625 12.4679 13.5971 12.3741C13.4317 12.2803 13.294 12.1443 13.1981 11.9801C13.1022 11.8159 13.0514 11.6292 13.051 11.439V9.51297C13.0508 9.32253 13.1012 9.13546 13.197 8.97086C13.2927 8.80626 13.4305 8.67003 13.5961 8.57607C13.7618 8.48212 13.9494 8.43381 14.1398 8.43607C14.3302 8.43834 14.5166 8.4911 14.68 8.58897L16.287 9.55297C16.4467 9.64821 16.579 9.78329 16.6708 9.945C16.7627 10.1067 16.811 10.2895 16.811 10.4755C16.811 10.6614 16.7627 10.8442 16.6708 11.006C16.579 11.1677 16.4467 11.3027 16.287 11.398V11.399Z"
            fill="#BFBFBF"
        />
    </svg>
);

export const NavSVG3 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.405"
        height="27.19"
        viewBox="0 0 24.405 27.19"
    >
        <g
            id="Group_87"
            dataname="Group 87"
            transform="translate(-679.163 -663.465)"
        >
            <path
                id="Path_494"
                dataname="Path 494"
                d="M713.293,695.009a1.835,1.835,0,0,0-2.6,2.6l2.52,2.524a1.838,1.838,0,0,0,2.6-2.6Zm.5,4.48a.974.974,0,1,1,1.377,0A.97.97,0,0,1,713.794,699.489Z"
                transform="translate(-19.336 -19.342)"
                fill="#bfbfbf"
            />
            <path
                id="Path_495"
                dataname="Path 495"
                d="M702.952,686.886l-1.322-1.445.527-.527a1.154,1.154,0,0,0,0-1.625l-.918-.918.2-.2a1.144,1.144,0,0,0,.034-1.588l-8.686-9.469a.891.891,0,0,0-.023-1.234l-1.264-1.264a.916.916,0,0,0-.986-.181,5.6,5.6,0,0,0-.82-2.3,1.313,1.313,0,0,0-.218-1.557l0,0s0,0-.008-.008a1.347,1.347,0,0,0-1.557-.218,5.7,5.7,0,0,0-7.868,7.857,1.319,1.319,0,0,0,1.791,1.79,5.57,5.57,0,0,0,2.287.828.9.9,0,0,0,.188.982l1.264,1.264a.88.88,0,0,0,1.234.023l9.457,8.7a1.141,1.141,0,0,0,1.587-.034l.2-.2.918.918a1.148,1.148,0,0,0,1.621,0l.5-.5,0,0,1.3,1.42a1.476,1.476,0,0,1-2.132,2.04l-.659-.659a2.227,2.227,0,0,0-3.151,0l-.677.677a.376.376,0,1,0,.532.532l.677-.677a1.511,1.511,0,0,1,2.087,0l.659.659a2.228,2.228,0,1,0,3.219-3.08Zm-5.632-1.664a.4.4,0,0,1-.549.015l-9.431-8.679,4.913-4.913,8.667,9.442a.393.393,0,0,1-.011.545Zm-10.014-20.359-6.741,6.741a4.945,4.945,0,0,1,6.741-6.741Zm1.866,1.866a4.839,4.839,0,0,1,.639,2.314l-5.075,5.075a4.883,4.883,0,0,1-2.31-.643Z"
                fill="#bfbfbf"
            />
        </g>
    </svg>
);

export const NavSVG4 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30.183"
        height="30.071"
        viewBox="0 0 30.183 30.071"
    >
        <g
            id="Group_10"
            dataname="Group 10"
            transform="translate(-432.949 -52.172)"
        >
            <path
                id="Path_71"
                dataname="Path 71"
                d="M461.244,53.186a3.686,3.686,0,0,0-4.152-.663,8.56,8.56,0,0,1-6.309,0,3.7,3.7,0,0,0-4.156.663c-1.98,1.882-2.017,5.595-1.775,8.088a8.546,8.546,0,0,1-5.87-.159,3.707,3.707,0,0,0-4.156.658c-3.124,2.975-1.41,10.526-1.392,10.6.234,1.009,2.466,9.868,8.7,9.868,2.648,0,4.983-1.677,6.757-4.847a21.015,21.015,0,0,0,1.84-4.628,6.2,6.2,0,0,0,3.2.883c4.71,0,7.556-5.26,8.692-9.817h0l0-.012h0a.32.32,0,0,1,.015-.061C462.921,62.47,464.13,55.921,461.244,53.186ZM448.08,76.943c-1.621,2.9-3.619,4.366-5.94,4.366-5.613,0-7.71-8.77-7.794-9.144-.019-.075-1.574-7.145,1.121-9.708a2.8,2.8,0,0,1,3.166-.477,9.5,9.5,0,0,0,6.328.238c.807-.219,2.366-1.167,3.839.233,1.55,1.471,1.686,4.4,1.55,6.538A18.015,18.015,0,0,1,448.08,76.943ZM450,59.295a2.129,2.129,0,0,0-2.036,1.5.2.2,0,0,1-.07.093,2.041,2.041,0,0,0-.243-.056,2.173,2.173,0,0,1-.131-.78,2.484,2.484,0,1,1,4.969,0,2.457,2.457,0,0,1-.112.738.176.176,0,0,1-.336,0A2.126,2.126,0,0,0,450,59.295Zm8.434,10.839a.177.177,0,0,1-.336,0,4.377,4.377,0,0,0-6.771-2.153,14.01,14.01,0,0,0-.28-3.054,4.679,4.679,0,0,1,2.891-.995,4.746,4.746,0,0,1,4.5,6.2Zm1.915-9.345a.178.178,0,0,1-.336,0,2.136,2.136,0,0,0-4.077,0,.175.175,0,0,1-.336,0,2.611,2.611,0,0,1-.107-.738,2.482,2.482,0,1,1,4.964,0,2.609,2.609,0,0,1-.107.738Z"
                fill="#bfbfbf"
            />
            <path
                id="Path_72"
                dataname="Path 72"
                d="M443.41,85.351a.176.176,0,0,0,.336,0,2.456,2.456,0,0,0,.112-.737,2.484,2.484,0,0,0-4.969,0,2.457,2.457,0,0,0,.112.737.172.172,0,0,0,.332,0,2.136,2.136,0,0,1,4.077,0Z"
                transform="translate(-3.166 -15.965)"
                fill="#bfbfbf"
            />
            <path
                id="Path_73"
                dataname="Path 73"
                d="M451.548,95.754a.181.181,0,0,0-.168.121,4.378,4.378,0,0,1-8.322,0,.177.177,0,0,0-.336,0,4.731,4.731,0,1,0,8.994,0,.181.181,0,0,0-.168-.121Z"
                transform="translate(-5.085 -23.229)"
                fill="#bfbfbf"
            />
            <path
                id="Path_74"
                dataname="Path 74"
                d="M458.233,82.134a2.483,2.483,0,0,0-2.274,2.475,2.609,2.609,0,0,0,.107.737.176.176,0,0,0,.336,0,2.136,2.136,0,0,1,4.077,0,.178.178,0,0,0,.336,0,2.644,2.644,0,0,0,.107-.737,2.485,2.485,0,0,0-2.69-2.475Z"
                transform="translate(-12.264 -15.965)"
                fill="#bfbfbf"
            />
        </g>
    </svg>
);

export const NavSVG5 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27.575"
        height="28.19"
        viewBox="0 0 27.575 28.19"
    >
        <g
            id="Group_138"
            dataname="Group 138"
            transform="translate(-679.429 -784.555)"
        >
            <path
                id="Path_796"
                dataname="Path 796"
                d="M689.736,814.036h2.727a.436.436,0,1,0,0-.872h-2.727a.436.436,0,0,0,0,.872Z"
                transform="translate(-5.565 -16.129)"
                fill="#bfbfbf"
            />
            <path
                id="Path_797"
                dataname="Path 797"
                d="M711.965,813.164H700.636a.436.436,0,1,0,0,.872h11.329a.436.436,0,1,0,0-.872Z"
                transform="translate(-11.71 -16.129)"
                fill="#bfbfbf"
            />
            <path
                id="Path_798"
                dataname="Path 798"
                d="M689.736,818.906H700.4a.436.436,0,0,0,0-.872H689.736a.436.436,0,0,0,0,.872Z"
                transform="translate(-5.565 -18.874)"
                fill="#bfbfbf"
            />
            <path
                id="Path_799"
                dataname="Path 799"
                d="M722.417,818.034h-3.241a.436.436,0,1,0,0,.872h3.241a.436.436,0,0,0,0-.872Z"
                transform="translate(-22.162 -18.874)"
                fill="#bfbfbf"
            />
            <path
                id="Path_800"
                dataname="Path 800"
                d="M689.736,823.773h6.517a.436.436,0,0,0,0-.872h-6.517a.436.436,0,0,0,0,.872Z"
                transform="translate(-5.565 -21.618)"
                fill="#bfbfbf"
            />
            <path
                id="Path_801"
                dataname="Path 801"
                d="M717.1,822.9h-7.359a.436.436,0,0,0,0,.872H717.1a.436.436,0,0,0,0-.872Z"
                transform="translate(-16.84 -21.618)"
                fill="#bfbfbf"
            />
            <path
                id="Path_802"
                dataname="Path 802"
                d="M689.736,828.646h3.516a.436.436,0,0,0,0-.872h-3.516a.436.436,0,0,0,0,.872Z"
                transform="translate(-5.565 -24.365)"
                fill="#bfbfbf"
            />
            <path
                id="Path_803"
                dataname="Path 803"
                d="M706.135,827.774h-4.179a.436.436,0,0,0,0,.872h4.179a.436.436,0,1,0,0-.872Z"
                transform="translate(-12.454 -24.365)"
                fill="#bfbfbf"
            />
            <path
                id="Path_804"
                dataname="Path 804"
                d="M696.851,832.644h-7.115a.436.436,0,0,0,0,.872h7.115a.436.436,0,0,0,0-.872Z"
                transform="translate(-5.565 -27.111)"
                fill="#bfbfbf"
            />
            <path
                id="Path_805"
                dataname="Path 805"
                d="M683.308,795.85a.458.458,0,1,0-.458-.458A.458.458,0,0,0,683.308,795.85Z"
                transform="translate(-1.929 -5.851)"
                fill="#bfbfbf"
            />
            <path
                id="Path_806"
                dataname="Path 806"
                d="M682.887,803.55a.458.458,0,1,0-.458-.458A.458.458,0,0,0,682.887,803.55Z"
                transform="translate(-1.691 -10.192)"
                fill="#bfbfbf"
            />
            <circle
                id="Ellipse_8"
                dataname="Ellipse 8"
                cx="0.493"
                cy="0.493"
                r="0.493"
                transform="translate(683.399 792.978)"
                fill="#bfbfbf"
            />
            <path
                id="Path_807"
                dataname="Path 807"
                d="M705.25,803.387H703.6v-7.953a1.213,1.213,0,0,0,.824-1.152v-2.4a.436.436,0,0,0-.436-.436h-18.13s0-.009-.009-.017l17.881-3.028a.439.439,0,0,0,.358-.5l-.353-2.076a1.518,1.518,0,0,0-1.749-1.243l-19.543,3.312h0a1.028,1.028,0,0,0-.236-.027h-1.592a1.178,1.178,0,0,0-1.178,1.178v5.283a1.186,1.186,0,0,0,1.178,1.178h.327v10.276a3.037,3.037,0,0,0,3.032,3.036h12.188v.314a1.758,1.758,0,0,0,1.374,1.71v1.082a.824.824,0,0,0,1.3.672l2.378-1.71h4.039A1.754,1.754,0,0,0,707,809.126v-3.983A1.758,1.758,0,0,0,705.25,803.387Zm-4.153,2.33a.267.267,0,0,1-.2.079.3.3,0,0,1-.122-.026,2.312,2.312,0,0,0-.427-.174,1.747,1.747,0,0,0-.476-.057,1.413,1.413,0,0,0-.715.17,1.109,1.109,0,0,0-.441.467,1.658,1.658,0,0,0,0,1.37,1.1,1.1,0,0,0,.336.4c.035.026.07.048.1.07a1.413,1.413,0,0,0,.715.174,1.723,1.723,0,0,0,.476-.061,2.048,2.048,0,0,0,.427-.174.292.292,0,0,1,.122-.026.281.281,0,0,1,.2.074.275.275,0,0,1,.044.314.246.246,0,0,1-.118.122,2.774,2.774,0,0,1-.554.24,2.243,2.243,0,0,1-.641.083,1.948,1.948,0,0,1-.947-.227,1.582,1.582,0,0,1-.227-.153,1.619,1.619,0,0,1-.388-.436.765.765,0,0,1-.048-.078,2.218,2.218,0,0,1,0-2.007,1.645,1.645,0,0,1,.663-.663,1.951,1.951,0,0,1,.947-.231,2.221,2.221,0,0,1,.641.083,2.916,2.916,0,0,1,.558.24.278.278,0,0,1,.144.253.262.262,0,0,1-.074.179Zm-3.184-2.33a1.761,1.761,0,0,0-1.758,1.758v2.8H683.966a2.162,2.162,0,0,1-2.159-2.164V795.5h20.918v7.883Zm4.96-17.423.279,1.645-1.88.318.563-2.438.3-.053a.647.647,0,0,1,.742.528Zm-3.137-.122-.567,2.443-2.1.353.567-2.443ZM694.972,789l-2.1.353.567-2.443,2.1-.354Zm-4.2.711-2.1.353.563-2.443,2.1-.353Zm-4.2.711-1.3.223-.62-.668.38-1.645,2.1-.353Zm16.974,3.865a.345.345,0,0,1-.345.345h-1.562l.96-2.312h.947Zm-4.035.345h-2.129l.955-2.312h2.133Zm-4.262,0h-2.129l.96-2.312h2.129Zm-4.253,0h-2.129l.955-2.312h2.133Zm-4.262,0h-.872a1.169,1.169,0,0,0,.039-.305v-2.007H687.7Zm-6.435-.305v-5.283a.305.305,0,0,1,.305-.305H682.2a.323.323,0,0,1,.222.1c.174.188,2.7,2.92,2.526,2.735a.305.305,0,0,1,.083.209v2.548a.309.309,0,0,1-.305.305c-3.777,0-4.122.01-4.166,0a.305.305,0,0,1-.257-.3Zm22.911,11.386c-.017.013-.035.022-.052.035a1.078,1.078,0,0,0-.384.432,1.519,1.519,0,0,0-.148.685,1.618,1.618,0,0,0,.052.419,1.072,1.072,0,0,0,.1.266.828.828,0,0,0,.113.179.98.98,0,0,0,.323.288,1.414,1.414,0,0,0,.716.174,1.73,1.73,0,0,0,.48-.061,2.262,2.262,0,0,0,.427-.174.278.278,0,0,1,.122-.026.262.262,0,0,1,.192.074.251.251,0,0,1,.078.183.273.273,0,0,1-.148.253,2.7,2.7,0,0,1-.558.24,2.209,2.209,0,0,1-.637.083,1.947,1.947,0,0,1-.947-.227,1.626,1.626,0,0,1-.471-.388,1.6,1.6,0,0,1-.2-.279.8.8,0,0,1-.044-.087,1.725,1.725,0,0,1-.148-.454,1.977,1.977,0,0,1-.048-.462,2.056,2.056,0,0,1,.24-1,1.651,1.651,0,0,1,.454-.523,1.392,1.392,0,0,1,.214-.14,1.807,1.807,0,0,1,.222-.1,2.006,2.006,0,0,1,.724-.126,2.209,2.209,0,0,1,.637.083,2.694,2.694,0,0,1,.558.24.274.274,0,0,1,.148.253.262.262,0,0,1-.074.179.266.266,0,0,1-.2.079.281.281,0,0,1-.122-.026,2.6,2.6,0,0,0-.427-.174,1.76,1.76,0,0,0-.48-.057,1.355,1.355,0,0,0-.331.035A1.088,1.088,0,0,0,703.213,805.708Z"
                transform="translate(0 0)"
                fill="#bfbfbf"
            />
        </g>
    </svg>
);

export const NavSVG6 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27.334"
        height="27.374"
        viewBox="0 0 27.334 27.374"
    >
        <g
            id="Group_101"
            dataname="Group 101"
            transform="translate(-801.741 -417.564)"
        >
            <path
                id="Path_576"
                dataname="Path 576"
                d="M828.31,450.686c-.037-.064.448.366-7.654-6.522a1.967,1.967,0,0,0-3.022.6l-1.387,2.687a1.189,1.189,0,0,0,.289,1.442,1.174,1.174,0,0,0,1.828-.386l.884-1.844a.057.057,0,0,1,.038-.025h.008a.042.042,0,0,1,.029.008l3.709,3.869H807.784l3.705-3.864a.051.051,0,0,1,.042-.013.057.057,0,0,1,.038.025l.884,1.844a1.183,1.183,0,1,0,2.117-1.056l-1.387-2.687a1.967,1.967,0,0,0-3.022-.6l-7.586,6.447a.405.405,0,0,0-.071.079,1.454,1.454,0,0,0-.754,1.425l.679,6.685a1.443,1.443,0,0,0,1.446,1.316h6.811a2.3,2.3,0,0,0,2.129-1.417l1.241-2.98a1.465,1.465,0,0,1,2.708,0L818,458.7a2.305,2.305,0,0,0,2.129,1.417h6.811a1.443,1.443,0,0,0,1.446-1.312l.679-6.689A1.461,1.461,0,0,0,828.31,450.686Zm-1.366,8.592h-6.811a1.457,1.457,0,0,1-1.354-.9l-1.241-2.98a2.305,2.305,0,0,0-4.258,0l-1.236,2.98a1.467,1.467,0,0,1-1.358.9h-6.811a.612.612,0,0,1-.612-.557l-.679-6.69a.62.62,0,0,1,.612-.683h24.427a.619.619,0,0,1,.612.683l-.679,6.69A.611.611,0,0,1,826.943,459.278Z"
                transform="translate(0 -15.178)"
                fill="#bfbfbf"
            />
            <path
                id="Path_577"
                dataname="Path 577"
                d="M814.7,464.634h-6.878a1.021,1.021,0,0,0-1.01,1.119l.369,3.651a1.014,1.014,0,0,0,1.01.914h4.992a1.006,1.006,0,0,0,.935-.625l1.521-3.651a1.018,1.018,0,0,0-.939-1.408Z"
                transform="translate(-2.943 -27.341)"
                fill="#bfbfbf"
            />
            <path
                id="Path_578"
                dataname="Path 578"
                d="M848.528,464.634H841.65a1.018,1.018,0,0,0-.939,1.408l1.521,3.651a1.006,1.006,0,0,0,.935.625h4.992a1.014,1.014,0,0,0,1.01-.914l.369-3.651a1.017,1.017,0,0,0-1.01-1.119Z"
                transform="translate(-22.591 -27.341)"
                fill="#bfbfbf"
            />
            <path
                id="Path_579"
                dataname="Path 579"
                d="M829.323,417.564h-9.791A2.531,2.531,0,0,0,817,420.092v4.178a2.531,2.531,0,0,0,2.532,2.527l2.963.013,1.22,1.773a.867.867,0,0,0,1.425,0l1.241-1.786h2.942a2.531,2.531,0,0,0,2.532-2.528v-4.178A2.531,2.531,0,0,0,829.323,417.564Zm1.693,6.706a1.693,1.693,0,0,1-1.693,1.689H826.38a.869.869,0,0,0-.713.377l-1.228,1.789-.034-.021-1.22-1.769a.869.869,0,0,0-.713-.377h-2.942a1.693,1.693,0,0,1-1.693-1.689v-4.179a1.693,1.693,0,0,1,1.693-1.689h9.791a1.693,1.693,0,0,1,1.693,1.69Z"
                transform="translate(-8.863)"
                fill="#bfbfbf"
            />
            <path
                id="Path_580"
                dataname="Path 580"
                d="M828.364,424.843a1.394,1.394,0,0,0,.3-.247,1.042,1.042,0,0,0,.222-.7,1,1,0,0,0-.4-.847,1.8,1.8,0,0,0-1.086-.293,2.541,2.541,0,0,0-1.19.306.316.316,0,0,0-.172.289.3.3,0,0,0,.1.226.314.314,0,0,0,.369.059,1.986,1.986,0,0,1,.851-.18,1.071,1.071,0,0,1,.616.143.4.4,0,0,1,.189.352.461.461,0,0,1-.256.427,1.67,1.67,0,0,1-.826.163h-.034a.346.346,0,0,0,0,.692h.092c1.165,0,1.165.465,1.165.62a.407.407,0,0,1-.247.4,1.715,1.715,0,0,1-.713.134,2.361,2.361,0,0,1-.876-.159.339.339,0,0,0-.39.075.346.346,0,0,0-.092.243.342.342,0,0,0,.059.2.4.4,0,0,0,.155.117,3.319,3.319,0,0,0,1.241.239,1.962,1.962,0,0,0,1.136-.31,1.048,1.048,0,0,0,.461-.905,1.029,1.029,0,0,0-.289-.788,1.463,1.463,0,0,0-.377-.256Z"
                transform="translate(-14.079 -3.017)"
                fill="#bfbfbf"
            />
            <path
                id="Path_581"
                dataname="Path 581"
                d="M836.029,427.128h1.157a2.158,2.158,0,0,0,1.169-.306,1.96,1.96,0,0,0,.725-.792,2.238,2.238,0,0,0,0-2.029,1.96,1.96,0,0,0-.725-.792,2.159,2.159,0,0,0-1.169-.306h-1.157a.342.342,0,0,0-.256.109.354.354,0,0,0-.1.26v3.491a.354.354,0,0,0,.1.26A.361.361,0,0,0,836.029,427.128Zm.373-.7V423.6h.721a1.6,1.6,0,0,1,.78.179,1.263,1.263,0,0,1,.511.495,1.6,1.6,0,0,1,0,1.475,1.29,1.29,0,0,1-.511.495,1.6,1.6,0,0,1-.78.18Z"
                transform="translate(-19.707 -3.101)"
                fill="#bfbfbf"
            />
        </g>
    </svg>
);

export const NavSVG7 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30.63"
        height="27.374"
        viewBox="0 0 30.63 27.374"
    >
        <g
            id="Group_59"
            dataname="Group 59"
            transform="translate(-428.258 -296.244)"
        >
            <path
                id="Path_326"
                dataname="Path 326"
                d="M458.158,296.244H444.829a2.745,2.745,0,0,0-2.74,2.745v21.885a2.745,2.745,0,0,0,2.74,2.745h13.329a2.747,2.747,0,0,0,2.745-2.745V298.989A2.747,2.747,0,0,0,458.158,296.244Zm1.887,24.629a1.887,1.887,0,0,1-1.887,1.887H444.829a1.887,1.887,0,0,1-1.883-1.887V298.989a1.887,1.887,0,0,1,1.883-1.887h13.329a1.89,1.89,0,0,1,1.887,1.887Z"
                transform="translate(-7.9 0)"
                fill="#bfbfbf"
            />
            <path
                id="Path_327"
                dataname="Path 327"
                d="M458.57,309.931a4.093,4.093,0,1,0-4.091-4.092,4.094,4.094,0,0,0,4.091,4.092Zm0-6.291a2.2,2.2,0,1,1-2.2,2.2A2.2,2.2,0,0,1,458.57,303.64Z"
                transform="translate(-14.976 -3.141)"
                fill="#bfbfbf"
            />
            <path
                id="Path_328"
                dataname="Path 328"
                d="M462.854,311a.877.877,0,1,0-.875-.875A.877.877,0,0,0,462.854,311Z"
                transform="translate(-19.26 -7.425)"
                fill="#bfbfbf"
            />
            <path
                id="Path_329"
                dataname="Path 329"
                d="M455.72,325.5a6.233,6.233,0,1,0,6.236,6.231,6.233,6.233,0,0,0-6.236-6.231Zm0,10.108a3.875,3.875,0,1,1,3.877-3.876,3.875,3.875,0,0,1-3.877,3.876Z"
                transform="translate(-12.126 -16.709)"
                fill="#bfbfbf"
            />
            <path
                id="Path_330"
                dataname="Path 330"
                d="M461.34,335.334a2.016,2.016,0,1,0,2.02,2.016A2.016,2.016,0,0,0,461.34,335.334Z"
                transform="translate(-17.746 -22.326)"
                fill="#bfbfbf"
            />
            <path
                id="Path_331"
                dataname="Path 331"
                d="M477.138,300.794a1.179,1.179,0,1,0,1.179,1.175,1.179,1.179,0,0,0-1.179-1.175Z"
                transform="translate(-27.244 -2.599)"
                fill="#bfbfbf"
            />
            <path
                id="Path_332"
                dataname="Path 332"
                d="M447.764,303.153a1.179,1.179,0,1,0-1.175-1.184A1.179,1.179,0,0,0,447.764,303.153Z"
                transform="translate(-10.47 -2.599)"
                fill="#bfbfbf"
            />
            <circle
                id="Ellipse_1"
                dataname="Ellipse 1"
                cx="1.179"
                cy="1.179"
                r="1.179"
                transform="translate(448.715 319.33)"
                fill="#bfbfbf"
            />
            <path
                id="Path_333"
                dataname="Path 333"
                d="M447.764,350.074a1.178,1.178,0,1,0,.837.343A1.179,1.179,0,0,0,447.764,350.074Z"
                transform="translate(-10.47 -30.744)"
                fill="#bfbfbf"
            />
            <path
                id="Path_334"
                dataname="Path 334"
                d="M495.191,319.508a.429.429,0,0,0-.606.607,4.292,4.292,0,0,1,0,6.065.429.429,0,1,0,.606.606A5.149,5.149,0,0,0,495.191,319.508Z"
                transform="translate(-37.81 -13.215)"
                fill="#bfbfbf"
            />
            <path
                id="Path_335"
                dataname="Path 335"
                d="M492.362,322.333a.429.429,0,1,0-.606.606,2.577,2.577,0,0,1,0,3.639.429.429,0,1,0,.606.606A3.431,3.431,0,0,0,492.362,322.333Z"
                transform="translate(-36.194 -14.828)"
                fill="#bfbfbf"
            />
            <path
                id="Path_336"
                dataname="Path 336"
                d="M489.534,325.165a.429.429,0,1,0-.606.606.858.858,0,0,1,0,1.213.429.429,0,1,0,.606.606A1.715,1.715,0,0,0,489.534,325.165Z"
                transform="translate(-34.579 -16.446)"
                fill="#bfbfbf"
            />
            <path
                id="Path_337"
                dataname="Path 337"
                d="M430.37,320.115a.429.429,0,0,0-.606-.607,5.149,5.149,0,0,0,0,7.278.429.429,0,1,0,.606-.606A4.292,4.292,0,0,1,430.37,320.115Z"
                transform="translate(0 -13.215)"
                fill="#bfbfbf"
            />
            <path
                id="Path_338"
                dataname="Path 338"
                d="M433.87,322.942a.429.429,0,1,0-.606-.608,3.435,3.435,0,0,0,0,4.852.429.429,0,1,0,.607-.606A2.577,2.577,0,0,1,433.87,322.942Z"
                transform="translate(-2.286 -14.829)"
                fill="#bfbfbf"
            />
            <path
                id="Path_339"
                dataname="Path 339"
                d="M437.364,325.165a.429.429,0,0,0-.606,0,1.715,1.715,0,0,0,0,2.426.429.429,0,1,0,.606-.606.858.858,0,0,1,0-1.213A.429.429,0,0,0,437.364,325.165Z"
                transform="translate(-4.568 -16.446)"
                fill="#bfbfbf"
            />
        </g>
    </svg>
);

export const PlayIcon1 = () => (
    <svg
        id="Fill_4"
        dataname="Fill 4"
        xmlns="http://www.w3.org/2000/svg"
        width="10.413"
        height="11.9"
        viewBox="0 0 10.413 11.9"
    >
        <path
            id="Fill_4-2"
            dataname="Fill 4"
            d="M10.413,5.957a1.715,1.715,0,0,1-.355,1.056,5.743,5.743,0,0,1-.414.463l-.089.087a22.54,22.54,0,0,1-5.9,3.933,5.169,5.169,0,0,1-1.376.4H2.219a1.866,1.866,0,0,1-1.642-.982A8.124,8.124,0,0,1,.222,9.6,26.222,26.222,0,0,1,0,5.943,22.629,22.629,0,0,1,.251,2.169,9.492,9.492,0,0,1,.518,1.113a1.9,1.9,0,0,1,.828-.9A2.115,2.115,0,0,1,2.278,0,5.122,5.122,0,0,1,3.505.333,22.646,22.646,0,0,1,9.54,4.323c.207.2.429.45.488.506a1.8,1.8,0,0,1,.385,1.128"
            fill="#bababa"
        />
    </svg>
);

export const PlayIcon2 = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17.944"
        height="17.944"
        viewBox="0 0 17.944 17.944"
    >
        <g
            id="Iconly_Light_Play"
            dataname="Iconly/Light/Play"
            transform="translate(0.75 0.75)"
        >
            <g id="Play">
                <path
                    id="Stroke_1"
                    data-name="Stroke 1"
                    d="M8.222,0A8.222,8.222,0,1,1,0,8.222,8.222,8.222,0,0,1,8.222,0Z"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <path
                    id="Stroke_3"
                    dataname="Stroke 3"
                    d="M4.243,3.264A12.264,12.264,0,0,1,1.177,5.355a3.275,3.275,0,0,1-.546.176.414.414,0,0,1-.377-.222,4.308,4.308,0,0,1-.136-.567A13.653,13.653,0,0,1,0,2.766,12.846,12.846,0,0,1,.13.723C.153.595.22.3.24.252A.409.409,0,0,1,.426.05.406.406,0,0,1,.631,0,2.87,2.87,0,0,1,1.1.147a12.154,12.154,0,0,1,3.13,2.111c.056.06.21.221.235.254a.412.412,0,0,1,.009.495C4.452,3.044,4.294,3.209,4.243,3.264Z"
                    transform="translate(6.487 5.342)"
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </g>
    </svg>
);

export const IconlySearch = ({ color }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="11.7666"
            cy="11.7666"
            r="8.98856"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.0183 18.4851L21.5423 22"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ArrowDownCircle = ({ color }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.75024 12C2.75024 17.108 6.89124 21.25 12.0002 21.25C17.1082 21.25 21.2502 17.108 21.2502 12C21.2502 6.892 17.1082 2.75 12.0002 2.75C6.89124 2.75 2.75024 6.892 2.75024 12Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.52905 10.5577L12.0001 14.0437L15.4711 10.5577"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const CameraIcon = ({ size }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.44 6.2364C17.48 6.30633 17.55 6.35627 17.64 6.35627C20.04 6.35627 22 8.3141 22 10.7114V16.6448C22 19.0422 20.04 21 17.64 21H6.36C3.95 21 2 19.0422 2 16.6448V10.7114C2 8.3141 3.95 6.35627 6.36 6.35627C6.44 6.35627 6.52 6.31632 6.55 6.2364L6.61 6.11654C6.64448 6.04397 6.67987 5.96943 6.71579 5.89376C6.97161 5.35492 7.25463 4.75879 7.43 4.40844C7.89 3.50943 8.67 3.00999 9.64 3H14.35C15.32 3.00999 16.11 3.50943 16.57 4.40844C16.7275 4.72308 16.9674 5.2299 17.1987 5.71839C17.2464 5.81921 17.2938 5.91924 17.34 6.01665L17.44 6.2364ZM16.71 10.0721C16.71 10.5716 17.11 10.9711 17.61 10.9711C18.11 10.9711 18.52 10.5716 18.52 10.0721C18.52 9.5727 18.11 9.16315 17.61 9.16315C17.11 9.16315 16.71 9.5727 16.71 10.0721ZM10.27 11.6204C10.74 11.1509 11.35 10.9012 12 10.9012C12.65 10.9012 13.26 11.1509 13.72 11.6104C14.18 12.0699 14.43 12.6792 14.43 13.3285C14.42 14.667 13.34 15.7558 12 15.7558C11.35 15.7558 10.74 15.5061 10.28 15.0466C9.82 14.5871 9.57 13.9778 9.57 13.3285V13.3185C9.56 12.6892 9.81 12.0799 10.27 11.6204ZM14.77 16.1054C14.06 16.8147 13.08 17.2542 12 17.2542C10.95 17.2542 9.97 16.8446 9.22 16.1054C8.48 15.3563 8.07 14.3774 8.07 13.3285C8.06 12.2897 8.47 11.3108 9.21 10.5616C9.96 9.81243 10.95 9.40289 12 9.40289C13.05 9.40289 14.04 9.81243 14.78 10.5516C15.52 11.3008 15.93 12.2897 15.93 13.3285C15.92 14.4173 15.48 15.3962 14.77 16.1054Z"
            fill="#BABABA"
        />
    </svg>
);

export const VolumeUp = ({ size }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.38268 3.07615C9.75636 3.23093 10 3.59557 10 4.00003V16C10 16.4045 9.75636 16.7691 9.38268 16.9239C9.00901 17.0787 8.57889 16.9931 8.29289 16.7071L4.58579 13H2C1.44772 13 1 12.5523 1 12V8.00003C1 7.44774 1.44772 7.00003 2 7.00003H4.58579L8.29289 3.29292C8.57889 3.00692 9.00901 2.92137 9.38268 3.07615Z"
            fill="#BABABA"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6568 2.92888C15.0474 2.53836 15.6805 2.53836 16.0711 2.92888C17.8796 4.73743 19 7.2388 19 9.99995C19 12.7611 17.8796 15.2625 16.0711 17.071C15.6805 17.4615 15.0474 17.4615 14.6568 17.071C14.2663 16.6805 14.2663 16.0473 14.6568 15.6568C16.1057 14.208 17 12.2094 17 9.99995C17 7.79053 16.1057 5.7919 14.6568 4.34309C14.2663 3.95257 14.2663 3.3194 14.6568 2.92888ZM11.8284 5.75731C12.2189 5.36678 12.8521 5.36678 13.2426 5.75731C13.7685 6.28319 14.1976 6.90687 14.5003 7.59958C14.822 8.33592 15 9.14847 15 9.99995C15 11.6565 14.3273 13.1579 13.2426 14.2426C12.8521 14.6331 12.2189 14.6331 11.8284 14.2426C11.4379 13.8521 11.4379 13.2189 11.8284 12.8284C12.5534 12.1034 13 11.1048 13 9.99995C13 9.42922 12.8811 8.8889 12.6676 8.40032C12.4663 7.93958 12.1802 7.52327 11.8284 7.17152C11.4379 6.781 11.4379 6.14783 11.8284 5.75731Z"
            fill="#BABABA"
        />
    </svg>
);

export const VolumeDown = ({ size }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.38268 3.07615C9.75636 3.23093 10 3.59557 10 4.00003V16C10 16.4045 9.75636 16.7691 9.38268 16.9239C9.00901 17.0787 8.57889 16.9931 8.29289 16.7071L4.58579 13H2C1.44772 13 1 12.5523 1 12V8.00003C1 7.44774 1.44772 7.00003 2 7.00003H4.58579L8.29289 3.29292C8.57889 3.00692 9.00901 2.92137 9.38268 3.07615Z"
            fill="#BABABA"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.2929 7.29289C12.6834 6.90237 13.3166 6.90237 13.7071 7.29289L15 8.58579L16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.29289C18.0976 7.68342 18.0976 8.31658 17.7071 8.70711L16.4142 10L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071C17.3166 13.0976 16.6834 13.0976 16.2929 12.7071L15 11.4142L13.7071 12.7071C13.3166 13.0976 12.6834 13.0976 12.2929 12.7071C11.9024 12.3166 11.9024 11.6834 12.2929 11.2929L13.5858 10L12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289Z"
            fill="#BABABA"
        />
    </svg>
);

export const ExpandIcon = ({ size }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="#bababa"
    >
        <title>expand-fullscreen-solid</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="invisible_box" data-name="invisible box">
                <rect width={size} height={size} fill="none" />
            </g>
            <g id="icons_Q2" data-name="icons Q2">
                <g>
                    <path d="M18.6,26.6,8,37.2V30.1A2.1,2.1,0,0,0,6.3,28,2,2,0,0,0,4,30V42a2,2,0,0,0,2,2H17.9A2.1,2.1,0,0,0,20,42.3,2,2,0,0,0,18,40H10.8L21.3,29.5a2.1,2.1,0,0,0,.3-2.7A1.9,1.9,0,0,0,18.6,26.6Z" />
                    <path d="M30,4a2,2,0,0,0-2,2.3A2.1,2.1,0,0,0,30.1,8h7.1L26.7,18.5a2,2,0,0,0-.2,2.8A1.8,1.8,0,0,0,28,22a2,2,0,0,0,1.4-.6L40,10.8v7.1A2.1,2.1,0,0,0,41.7,20,2,2,0,0,0,44,18V6a2,2,0,0,0-2-2Z" />
                </g>
            </g>
        </g>
    </svg>
);

export const StopIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
    >
        <rect
            id="Rectangle_20"
            dataname="Rectangle 20"
            width="12"
            height="12"
            rx="2"
            fill="#bababa"
        />
    </svg>
);

export const SkipFD = () => (
    <svg
        id="Group_9"
        data-name="Group 9"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
    >
        <path
            id="Fill_1"
            dataname="Fill 1"
            d="M20,10"
            transform="translate(-20 -6)"
            fill="#bababa"
            opacity="0.4"
        />
        <path
            id="Fill_4"
            dataname="Fill 4"
            d="M10.413,5.957a1.715,1.715,0,0,1-.355,1.056,5.743,5.743,0,0,1-.414.463l-.089.087a22.54,22.54,0,0,1-5.9,3.933,5.169,5.169,0,0,1-1.376.4H2.219a1.866,1.866,0,0,1-1.642-.982A8.124,8.124,0,0,1,.222,9.6,26.222,26.222,0,0,1,0,5.943,22.629,22.629,0,0,1,.251,2.169,9.492,9.492,0,0,1,.518,1.113a1.9,1.9,0,0,1,.828-.9A2.115,2.115,0,0,1,2.278,0,5.122,5.122,0,0,1,3.505.333,22.646,22.646,0,0,1,9.54,4.323c.207.2.429.45.488.506a1.8,1.8,0,0,1,.385,1.128"
            transform="translate(5.587)"
            fill="#bababa"
        />
        <rect
            id="Rectangle_19"
            dataname="Rectangle 19"
            width="2"
            height="12"
            rx="1"
            transform="translate(2.223)"
            fill="#bababa"
        />
    </svg>
);

export const SkipBD = () => (
    <svg
        id="Group_8"
        dataname="Group 8"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
    >
        <path
            id="Fill_1"
            dataname="Fill 1"
            d="M20,10"
            transform="translate(-4 -6)"
            fill="#bababa"
            opacity="0.4"
        />
        <path
            id="Fill_4"
            dataname="Fill 4"
            d="M0,5.957A1.715,1.715,0,0,0,.355,7.013a5.743,5.743,0,0,0,.414.463l.089.087a22.54,22.54,0,0,0,5.9,3.933,5.169,5.169,0,0,0,1.376.4h.059a1.866,1.866,0,0,0,1.642-.982A8.124,8.124,0,0,0,10.191,9.6a26.222,26.222,0,0,0,.222-3.66,22.629,22.629,0,0,0-.251-3.774,9.492,9.492,0,0,0-.266-1.056,1.9,1.9,0,0,0-.828-.9A2.115,2.115,0,0,0,8.135,0,5.122,5.122,0,0,0,6.907.333,22.646,22.646,0,0,0,.873,4.323c-.207.2-.429.45-.488.506A1.8,1.8,0,0,0,0,5.957"
            fill="#bababa"
        />
        <rect
            id="Rectangle_19"
            dataname="Rectangle 19"
            width="2"
            height="12"
            rx="1"
            transform="translate(12)"
            fill="#bababa"
        />
    </svg>
);

export const PauseIcon = () => (
    <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1 0C1.26522 0 1.51957 0.105357 1.70711 0.292893C1.89464 0.48043 2 0.734784 2 1V11C2 11.2652 1.89464 11.5196 1.70711 11.7071C1.51957 11.8946 1.26522 12 1 12C0.734784 12 0.48043 11.8946 0.292893 11.7071C0.105357 11.5196 0 11.2652 0 11V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM7 0C7.26522 0 7.51957 0.105357 7.70711 0.292893C7.89464 0.48043 8 0.734784 8 1V11C8 11.2652 7.89464 11.5196 7.70711 11.7071C7.51957 11.8946 7.26522 12 7 12C6.73478 12 6.48043 11.8946 6.29289 11.7071C6.10536 11.5196 6 11.2652 6 11V1C6 0.734784 6.10536 0.48043 6.29289 0.292893C6.48043 0.105357 6.73478 0 7 0Z"
            fill="#bababa"
        />
    </svg>
);

export const ImportVeditor = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="63.964"
        height="58.89"
        viewBox="0 0 63.964 58.89"
    >
        <g
            id="Group_218"
            dataname="Group 218"
            transform="translate(-925.409 -423.984)"
        >
            <path
                id="Path_1285"
                dataname="Path 1285"
                d="M987.729,472.314a59.2,59.2,0,0,0-4.51-4.39,14.5,14.5,0,0,0,2.5-7.82,14.317,14.317,0,0,0-1.529-6.77v-26.4a2.958,2.958,0,0,0-2.96-2.95H928.358a2.949,2.949,0,0,0-2.949,2.95v37.79a2.945,2.945,0,0,0,2.939,2.94h30.92a14.36,14.36,0,0,0,12.05,6.54,14.512,14.512,0,0,0,3.1-.34,40.394,40.394,0,0,0,3.53,6.11,7.447,7.447,0,0,0,4.319,2.75,5.919,5.919,0,0,0,4.911-1.06C989.751,479.625,990.224,475.507,987.729,472.314Zm-29.93-24.67-3.32,1.98a2.29,2.29,0,0,1-3.471-1.97v-3.97a2.3,2.3,0,0,1,3.471-1.97l3.32,1.99a2.293,2.293,0,0,1,0,3.94Zm6.36-.33a9.079,9.079,0,0,0,.12-1.49,9.485,9.485,0,1,0-9.48,9.49,9.153,9.153,0,0,0,3.019-.5,14.792,14.792,0,0,0-.789,3.29H941.6v-24.56h26.391V445.8a13.955,13.955,0,0,0-3.832,1.514Zm-36.75,10.79v-24.56H939.6V458.1Zm42.58-24.56h12.2v16.81a14.335,14.335,0,0,0-12.2-4.88Zm5.889-2h-4.31v-5.56h4.31Zm-12.62,0h-4.309v-5.56h4.309Zm-12.62,0h-4.31v-5.56h4.31Zm-12.62,0h-4.309v-5.56h4.309Zm-4.309,28.56h4.309v5.56h-4.309Zm12.619,0h4.31v5.56h-4.31Zm24.435,12.1a12.428,12.428,0,1,1,9.067-3.386,12.4,12.4,0,0,1-9.067,3.386Zm15.176,7.893c-1.974,1.515-4.816.686-6.41-1.35a36.224,36.224,0,0,1-3.171-5.46,14.468,14.468,0,0,0,5.621-3.8,46.413,46.413,0,0,1,4.17,4.06c1.582,2.01,1.745,4.991-.21,6.547Z"
                fill="#fff"
            />
            <path
                id="Path_1286"
                dataname="Path 1286"
                d="M980.828,460.1a9.527,9.527,0,1,0-3.148,6.769A9.51,9.51,0,0,0,980.828,460.1Zm-7.269-2.35a1,1,0,0,1,1.449,1.35c-.14.225-4.243,3.512-4.44,3.61a.97.97,0,0,1-1-.11,17.346,17.346,0,0,1-1.95-2.5.989.989,0,0,1,1.6-1c.1.06,1.009,1.19,1.09,1.29.429-.342,3.151-2.555,3.251-2.636Z"
                fill="#fff"
            />
        </g>
    </svg>
);

export const ImportDevice = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60.89"
        height="64.4"
        viewBox="0 0 60.89 64.4"
    >
        <g
            id="Digital_Cinema"
            dataname="Digital Cinema"
            transform="translate(-186.71 -540.36)"
        >
            <g id="Group_90" dataname="Group 90">
                <path
                    id="Path_506"
                    dataname="Path 506"
                    d="M241.6,554.5H228.86c0-9.841,0-.374.01-7.309a6.839,6.839,0,0,0-6.83-6.831h-28.5a6.833,6.833,0,0,0-6.83,6.831V597.93a6.833,6.833,0,0,0,6.83,6.83h28.5a6.839,6.839,0,0,0,6.83-6.83c0-.115,0-.235-.01-9.18H241.6a6,6,0,0,0,6-6V560.5a6,6,0,0,0-6-6Zm4,28.25a4,4,0,0,1-4,4H214.73a4,4,0,0,1-4-4V564.06H245.6Zm-18.74,10.29H188.72V548.87h38.14v5.63H214.73a6.005,6.005,0,0,0-6,6v22.25a6,6,0,0,0,6,6h12.13Zm15.17-33.16a1.434,1.434,0,1,1-.419-1.018,1.435,1.435,0,0,1,.419,1.018Zm-5.35,0a1.44,1.44,0,1,1-.421-1.016,1.44,1.44,0,0,1,.421,1.016Zm-5.36,0a1.434,1.434,0,1,1-.419-1.018,1.435,1.435,0,0,1,.419,1.018Zm-24.87-16.33h4.59a1,1,0,0,1,0,2h-4.59a1,1,0,0,1,0-2Zm2.91,57.891a2.013,2.013,0,1,1,1.43-.589,2.021,2.021,0,0,1-1.43.589Z"
                    fill="#fff"
                />
                <path
                    id="Path_507"
                    dataname="Path 507"
                    d="M228.169,567.244a7.975,7.975,0,1,0,7.97,7.98,7.975,7.975,0,0,0-7.97-7.98Zm2.11,6.49a1.584,1.584,0,0,1,0,2.73l-1.42.85c-.56.257-1.085.9-2,.7a1.594,1.594,0,0,1-1.26-1.56v-2.72a1.6,1.6,0,0,1,2.41-1.37Z"
                    fill="#fff"
                />
            </g>
        </g>
    </svg>
);

export const MusicIcon = ({ size }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size * 1.00399}
        viewBox="0 0 12.778 12.829"
    >
        <path
            id="noun-music-4711478"
            d="M90.915,23.982H89.627a2.13,2.13,0,1,0,2.13,2.132l.011-6.042,7.656-1.533v5.443H98.134a2.13,2.13,0,1,0,2.13,2.132l.011-8.572a2.13,2.13,0,0,0-2.548-2.088l-5.1,1.021a2.13,2.13,0,0,0-1.711,2.088Z"
            transform="translate(-87.497 -15.413)"
            fill="#bababa"
            fillRule="evenodd"
        />
    </svg>
);
